import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

import FlexibleContentsRouter from '../util/FlexibleContentsRouter';
import flexibleContentFullWidthVideo from './flexible-contents/flexibleContentFullWidthVideo';
import flexibleContentFeaturedFundsSlider from './flexible-contents/flexibleContentFeaturedFundsSlider';

export default {
  init() {
    // Header banner - Adjust .banner-visual-arrow depending on length of text
    const $heroBNannerTitleCol = $('.hero-banner .hero-banner-title-col');
    const $bannerVisualArrow = $heroBNannerTitleCol.find('.banner-visual-arrow');
    const $heroBannerTitle = $heroBNannerTitleCol.find('.hero-banner-title');

    function setBannerVisualArrowHeight() {
      const heroBannerTitleHeight = ($heroBNannerTitleCol.height() - $heroBannerTitle.position().top);
      $bannerVisualArrow.height(heroBannerTitleHeight);
    }

    setBannerVisualArrowHeight();

    $(window).resize(function() {
      setBannerVisualArrowHeight();
    });

    // Mobile navigation
    const $navPrimaryMbContainer = $(".nav-primary-mb-container");
    const $mobileBurgerStackButton = $(".mobile-burger-stack-button");

    $mobileBurgerStackButton.on("click", function() {
      $navPrimaryMbContainer.toggleClass("open");

      // Toggle primary-nav-open class in body
      $("body").toggleClass("primary-nav-open");

      // Jump to top of page
      $('html,body').scrollTop(0);

    });

    // Open search popup
    const $searchPopupTrigger = $('.hero-banner .search-button');
    $searchPopupTrigger.on('click', function() {
      $('.global-search-popup').addClass('open');
    });

    // Close search popup
    const $searchPopupClose = $('.global-search-popup .search-close');
    $searchPopupClose.on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      $('.global-search-popup').removeClass('open');
    });

    // Match height all .resources-wrap .resource-inner and .resources-wrap .resource-item
    const $resourcesWrap = $('.resources-wrap');
    const $resourceInner = $resourcesWrap.find('.resource-inner');
    $resourceInner.matchHeight();

    const $resourceItem = $resourcesWrap.find('.resource-item');
    $resourceItem.matchHeight();

    //Only run if search results are present.
    let resultsContainer = document.querySelector('.search-results-container');
    if(resultsContainer) {

      //Get all search result elements.
      let resultItems = document.querySelectorAll('.result-item');

      const tl = gsap.timeline();
      const tween = gsap.fromTo(resultItems,
      {
        autoAlpha: 0,
      },
      {
        autoAlpha: 1,
        duration: 1,
        stagger: 0.2,
        ease: 'power2.easeIn',
      });

      tl.add(tween);
      tl.play();
    }

  },
  finalize() {
    // Flexible contents
    // Loop through all .flexible-content-container and store into array
    const flexibleContentContainers = document.querySelectorAll('.flexible-content-container');

    const flexibleRouter = new FlexibleContentsRouter({
      flexibleContentFullWidthVideo,
      flexibleContentFeaturedFundsSlider,
    }, flexibleContentContainers);

    flexibleRouter.loadEvents();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js